import { c as _c } from "react/compiler-runtime";
import type { TenantScope } from '@onefootprint/request-types/dashboard';
import { Divider } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useGetRoleText from '../../role-display/role-permissions/use-get-role-text';
const ApiKeyDetails = t0 => {
  const $ = _c(53);
  const {
    name,
    scopes,
    roleName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.apiKeys"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  const getRoleText = useGetRoleText();
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[1] !== getRoleText || $[2] !== name || $[3] !== roleName || $[4] !== scopes || $[5] !== t) {
    let t9;
    if ($[13] !== getRoleText) {
      t9 = scope => getRoleText(scope as TenantScope);
      $[13] = getRoleText;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    const roleText = scopes.map(t9);
    t6 = "flex flex-col gap-4";
    let t10;
    if ($[15] !== t) {
      t10 = t(_temp);
      $[15] = t;
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    let t11;
    if ($[17] !== t10) {
      t11 = <span className="text-body-2 text-tertiary">{t10}</span>;
      $[17] = t10;
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    let t12;
    if ($[19] !== name) {
      t12 = <span className="text-body-2">{name}</span>;
      $[19] = name;
      $[20] = t12;
    } else {
      t12 = $[20];
    }
    let t13;
    if ($[21] !== t11 || $[22] !== t12) {
      t13 = <div className="flex flex-col gap-2 min-w-[140px]">{t11}{t12}</div>;
      $[21] = t11;
      $[22] = t12;
      $[23] = t13;
    } else {
      t13 = $[23];
    }
    let t14;
    if ($[24] !== t) {
      t14 = t(_temp2);
      $[24] = t;
      $[25] = t14;
    } else {
      t14 = $[25];
    }
    let t15;
    if ($[26] !== t14) {
      t15 = <span className="text-body-2 text-tertiary">{t14}</span>;
      $[26] = t14;
      $[27] = t15;
    } else {
      t15 = $[27];
    }
    let t16;
    if ($[28] !== roleName) {
      t16 = <span className="text-body-2">{roleName}</span>;
      $[28] = roleName;
      $[29] = t16;
    } else {
      t16 = $[29];
    }
    let t17;
    if ($[30] !== t15 || $[31] !== t16) {
      t17 = <div className="flex flex-col gap-2 min-w-[140px]">{t15}{t16}</div>;
      $[30] = t15;
      $[31] = t16;
      $[32] = t17;
    } else {
      t17 = $[32];
    }
    if ($[33] !== t13 || $[34] !== t17) {
      t7 = <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-9 gap-y-4">{t13}{t17}</div>;
      $[33] = t13;
      $[34] = t17;
      $[35] = t7;
    } else {
      t7 = $[35];
    }
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <Divider variant="secondary" />;
      $[36] = t8;
    } else {
      t8 = $[36];
    }
    t4 = "flex flex-col gap-4 px-4 py-3 rounded bg-secondary";
    let t18;
    if ($[37] !== t) {
      t18 = t(_temp3);
      $[37] = t;
      $[38] = t18;
    } else {
      t18 = $[38];
    }
    if ($[39] !== t18) {
      t5 = <h3 className="text-label-2">{t18}</h3>;
      $[39] = t18;
      $[40] = t5;
    } else {
      t5 = $[40];
    }
    t2 = `grid ${roleText.length > 2 ? "grid-cols-1 sm:grid-cols-2" : "grid-cols-1"} justify-between gap-x-9 gap-y-3`;
    t3 = roleText.map(_temp4);
    $[1] = getRoleText;
    $[2] = name;
    $[3] = roleName;
    $[4] = scopes;
    $[5] = t;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[41] !== t2 || $[42] !== t3) {
    t9 = <div className={t2}>{t3}</div>;
    $[41] = t2;
    $[42] = t3;
    $[43] = t9;
  } else {
    t9 = $[43];
  }
  let t10;
  if ($[44] !== t4 || $[45] !== t5 || $[46] !== t9) {
    t10 = <div className={t4}>{t5}{t9}</div>;
    $[44] = t4;
    $[45] = t5;
    $[46] = t9;
    $[47] = t10;
  } else {
    t10 = $[47];
  }
  let t11;
  if ($[48] !== t10 || $[49] !== t6 || $[50] !== t7 || $[51] !== t8) {
    t11 = <div className={t6}>{t7}{t8}{t10}</div>;
    $[48] = t10;
    $[49] = t6;
    $[50] = t7;
    $[51] = t8;
    $[52] = t11;
  } else {
    t11 = $[52];
  }
  return t11;
};
export default ApiKeyDetails;
function _temp($) {
  return $.name;
}
function _temp2($_0) {
  return $_0.role;
}
function _temp3($_1) {
  return $_1.permissions;
}
function _temp4(text) {
  return <div key={text}><span className="text-body-2 md:whitespace-nowrap">{text}</span></div>;
}